import { ChipIcon } from "@picklebet/ui";
import React, { useMemo } from "react";
import { Row } from "./Row/Row";
import { ResultsInIndex } from "./ResultsInIndex/ResultsInIndex";
import { Highlight } from "./Highlight/Highlight";
import { useNormalisedHits } from "@/features/search/components/Results/hooks/useNormalisedHits";
import type { CasinoProviderHit } from "@/features/search/components/Results/models/casinoProviderHit";
import { getProviderPath } from "@/features/casino/utils/helpers";
import { useCasinoCategoryCounts } from "@/features/casino/hooks/useCasinoCategoryCounts";
import { useConfigure } from "react-instantsearch";
import * as styles from "@/features/search/components/Results/Results.module.scss";

const getFilters = (indexName: string, providers: string[]) => {
  const filters = [];
  if (indexName === "casino_providers" && providers) {
    filters.push(
      `${providers.map((provider) => `slug:${provider}`).join(" OR ")}`,
    );
  }

  return filters.join(" AND ");
};

const CasinoProvidersResults = () => {
  const { items, results } = useNormalisedHits<CasinoProviderHit>();
  const { providersWithResults } = useCasinoCategoryCounts();
  const indexName = "casino_providers";
  const filters = useMemo(() => {
    return getFilters(indexName, providersWithResults || []);
  }, [indexName, providersWithResults]);

  useConfigure({
    filters,
  });
  return (
    <ResultsInIndex
      indexName={`Casino Providers`}
      total={results?.nbHits || 0}
      pages={results?.nbPages || 0}
      perPage={results?.hitsPerPage || 0}
    >
      {(items || []).map((item) => {
        const titleHighlight = item.normalisedHighlights?.title?.[0];
        return (
          <Row
            key={item.objectID}
            iconClassName={styles.casinoProviderIconContainer}
            icon={
              item.icon ? (
                <div className={styles.casinoProviderImageContainer}>
                  <img
                    className={styles.casinoProviderImage}
                    src={item.icon}
                    alt={item.title}
                  />
                </div>
              ) : (
                <ChipIcon />
              )
            }
            title={
              <Highlight
                text={item.title}
                matchedWords={titleHighlight?.matchedWords || []}
                html={titleHighlight?.value || ""}
              />
            }
            to={getProviderPath(item.slug)}
          />
        );
      })}
    </ResultsInIndex>
  );
};

export { CasinoProvidersResults };
